import axios from 'axios'
const uploadFile = (data, url) => {
  return new Promise((resolve, reject) => {
    axios({
      url: url || '/old/batchExpertInit',
      method: 'post',
      data: data,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress(e) {
        // 返回上传进度
      }
    }).then(res => {
      resolve(res.data)
    })
  })
}
export default uploadFile



// WEBPACK FOOTER //
// ./src/utils/uploadFile.js